// Phase 13 — Money Hub: SE landing page with 4 tiles.
import { Link } from "react-router-dom";
import { Wallet, FileText, PackageX, Receipt } from "lucide-react";

const TILES = [
  { key: "payments",     to: "/money/payments",      label: "Payments",     icon: Wallet,   sub: "Record distributor payments", color: "from-sky-500 to-sky-600" },
  { key: "claims",       to: "/money/claims",        label: "Claims",       icon: FileText, sub: "Damage / scheme / expiry", color: "from-amber-500 to-amber-600" },
  { key: "sale-returns", to: "/money/sale-returns",  label: "Sale Returns", icon: PackageX, sub: "Return goods from outlet", color: "from-purple-500 to-purple-600" },
  { key: "expenses",     to: "/money/expenses",      label: "Expenses",     icon: Receipt,  sub: "Travel · food · lodging", color: "from-emerald-500 to-emerald-600" },
];

export default function MoneyHub() {
  return (
    <div className="max-w-lg mx-auto p-4 space-y-4" data-testid="money-hub-page">
      <div>
        <h1 className="text-xl font-semibold">Money</h1>
        <p className="text-xs text-neutral-500">Payments · Claims · Returns · Expenses</p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {TILES.map(t => {
          const Icon = t.icon;
          return (
            <Link key={t.key} to={t.to} data-testid={`money-tile-${t.key}`}
                  className={`bg-gradient-to-br ${t.color} rounded-lg p-4 text-white shadow-sm hover:shadow-md transition`}>
              <Icon className="w-6 h-6 mb-2" />
              <div className="font-semibold text-base">{t.label}</div>
              <div className="text-[11px] opacity-90 mt-0.5 leading-tight">{t.sub}</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
